import { render, staticRenderFns } from "./dianpu_casedetails.vue?vue&type=template&id=f32a8bde&scoped=true&"
import script from "./dianpu_casedetails.vue?vue&type=script&lang=js&"
export * from "./dianpu_casedetails.vue?vue&type=script&lang=js&"
import style0 from "./dianpu_casedetails.vue?vue&type=style&index=0&id=f32a8bde&prod&lang=less&scoped=true&"
import style1 from "./dianpu_casedetails.vue?vue&type=style&index=1&id=f32a8bde&prod&lang=css&"
import style2 from "./dianpu_casedetails.vue?vue&type=style&index=2&id=f32a8bde&prod&lang=less&scoped=true&"
import style3 from "./dianpu_casedetails.vue?vue&type=style&index=3&id=f32a8bde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32a8bde",
  null
  
)

export default component.exports